import { userImplement } from '@/config/hooks/user';
import { TrpcRequestConfig } from '@/infrastructure/axios';
import { BusiCode, HttpCode } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import { promptError } from '../error-info';

const GALILEO_TRACE_ID = 'x-galileo-trace-id';

const SECURE_BIZ_CODE = 51;

export interface TrpcAxiosResponse<T = any>  {
  data: T;
  status: number;
  statusText: string;
  headers: any;
  config: TrpcRequestConfig;
  request?: any;
}

/**
 * 回包拦截器
 * @param response
 */
export const onResFulfilled = (response: TrpcAxiosResponse) => {
  const { data, config } = response;
  if (response.config.headers['Server-Type'] === 'trpc') {
    const code = data?.base_rsp?.code ?? data?.baseRsp?.code ?? data?.BaseRsp?.code ?? data?.code;
    const { url } = response.config;

    if (code === BusiCode.ErrorToken) {
      // sassToken校验失败 去重新登录
      return userImplement.logout();
    }

    if (code !== BusiCode.Ok) {
      logger.info('Axios|onResFulfilled', code, url);
      if (config.ignoreError) return Promise.resolve(data);
      if (code === BusiCode.LimitUserAddProduct) return Promise.resolve(data);

      promptError({
        busiCode: code,
        msg: data?.base_rsp?.msg ?? data?.baseRsp?.msg ?? data?.BaseRsp?.msg ?? data?.msg,
        traceId: response.headers?.[GALILEO_TRACE_ID] || data?.traceId,
        url: url ?? '',
      });
      return Promise.reject(new Error(code));
    }
  }

  return Promise.resolve(data);
};

export const onResRejected = (error: any) => {
  const { response, config } = error;
  const status = response?.status;
  logger.error('Axios|onResRejected:', status, config);
  if (status === HttpCode.Unauthorized) {
    // 没登录就直接跳转，不要弹出消息了
    userImplement.logout();
  } else {
    const { data } = response;

    // 参数校验类错误
    const isSecureException = status === HttpCode.BadRequest  && data?.code === SECURE_BIZ_CODE;
    if (isSecureException) {
      promptError({
        busiCode: data?.code,
        msg: data?.msg,
        traceId: response?.headers?.[GALILEO_TRACE_ID] || data?.traceId,
        url: response?.config?.url || '',
      });
      return;
    }

    if (config.ignoreError) {
      return;
    }

    promptError({
      statusCode: status,
      msg: data?.msg,
      traceId: response?.headers?.[GALILEO_TRACE_ID] || data?.traceId,
      url: response?.config?.url || '',
    });
  }

  return Promise.reject(new Error(status));
};
